<div class="menu-container level-0 menu-bg-color rounded-2xl">
  <ul *ngIf="menuItemList && menuItemList.length > 0" class="menu-list text-center p-4">
    <ng-template ngFor let-menuItem [ngForOf]="menuItemList" let-i="index">
      <ng-template [ngIf]="menuItem.visible">
        <li [attr.data-test-id]="menuItem.testId">
          <a
            class="block text-center py-2 text-[10px] mb-2 rounded-xl cursor-pointer"
            [class.menu-item-bg-color]="indexNumber === i"
            [attr.aria-current]="indexNumber === i ? 'true' : null"
            [attr.tabindex]="indexNumber === i ? -1 : 0"
            href="javascript:void(0)"
            (click)="changeSelection($event, i)"
          >
            {{ menuItem.text }}
          </a>
          <thehubz-menu-sub-items [subMenuItemList]="subMenuItemList" *ngIf="indexNumber === i"></thehubz-menu-sub-items>
        </li>
        <mat-divider *ngIf="i < menuItemList.length - 1" class="divider-border-color"></mat-divider>
      </ng-template>
    </ng-template>
  </ul>
</div>
